/**
 * Created by renatolovizotto on 10/07/17.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';

import '../assets/stylesheets/Breadcrumb.scss';

@inject('Navigator', 'ConfigStore')
@observer
export default class Breadcrumb extends Component {

    static propTypes = {
        segments: PropTypes.array,
        onClick: PropTypes.func
    };

    static defaultProps = {
        segments: ['Index']
    };

    handleClick(uri, e) {
        if (this.props.onClick && uri && uri.length > 0) {
            this.props.onClick(uri || "/", e);
        }
    }

    render() {

        const {
            segments
        } = this.props;

        if (this.props.segments.length === 0)
            return null;

        let segmentsEl = segments.map(
            (segment, index) => <li key={index} onClick={this.handleClick.bind(this, segment.uri)}>{segment.title}</li>
        );

        return (<div className="Breadcrumb">
            <ul>{segmentsEl}</ul>
        </div>)
    }
}



// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js